import { useMutation, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

interface InstallUrlResponse {
  url: string;
}

interface InstalledRepo {
  id: number;
  name: string;
  full_name: string;
  private?: boolean;
}

interface GithubInstallationOut {
  id: string;
  installation_id: number;
  github_account_login: string;
  github_account_type: string | null;
  installed_repositories: InstalledRepo[] | null;
  created_at: string;
}

export interface InstallationStatus {
  installed: boolean;
  installation: GithubInstallationOut | null;
}

export function useInstallationStatus() {
  return useQuery({
    queryKey: ['github', 'status'],
    queryFn: () => api<InstallationStatus>('/api/github/status'),
    staleTime: 15_000,
  });
}

export function useRequestInstallUrl() {
  return useMutation({
    mutationFn: () => api<InstallUrlResponse>('/api/github/install-url'),
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });
}
